// ABOUTME: Icon button that opens ChangeGlPriceListDialog for a GL in Error status.
// ABOUTME: Renders nothing unless the GL is in error and has compatible price lists to pick.

import { ChangeCircleOutlinedIcon, IconButton, Tooltip } from '@ds/coolshop';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { ChangeGlPriceListDialog } from './ChangeGlPriceListDialog';

interface IChangeGlPriceListButtonProps {
    modelId: string;
    glId: string;
    isError: boolean;
    hasCompatiblePriceLists: boolean;
}

export function ChangeGlPriceListButton({
    modelId,
    glId,
    isError,
    hasCompatiblePriceLists,
}: IChangeGlPriceListButtonProps) {
    const intl = useIntl();
    const [open, setOpen] = useState(false);

    if (!isError || !hasCompatiblePriceLists) return null;

    return (
        <Tooltip
            title={intl.formatMessage({
                id: 'change-price-list.tooltip',
                defaultMessage: 'Cambia listino',
            })}
        >
            <>
                <IconButton onClick={() => setOpen(true)}>
                    <ChangeCircleOutlinedIcon />
                </IconButton>
                <ChangeGlPriceListDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    modelId={modelId}
                    glId={glId}
                />
            </>
        </Tooltip>
    );
}
